import axios from '@/api/config'
import { getOSSAuth } from '@/api/authAPI'
import { getWebsiteTextAPI, getWebsiteResourceByTypeAPI, getHeaderResourceByTypeAPI, getFewNews } from '@/api/resourceAPI'
import { getOssFile } from '@/util/file'

const state = {
  status: {},
  file: {},
  fileListSize: 0,
  path: {},
  resourceTexts: [],
  resources: [],
  news: [],
  avatar: ''
}

const getters = {
  getList: state => {
    return state.file
  },
  readFile: (state) => (id) => {
    return state.file[id]
  },
  size: (state) => {
    return state.fileListSize
  },
  homeTitle: (state) => {
    if (state.resourceTexts.length === 2) {
      return state.resourceTexts.find(r => r.type === 3001)
    } else {
      return JSON.parse(localStorage.resourceTexts).find(r => r.type === 3001)
    }
  },
  homeSubtitle: (state) => {
    if (state.resourceTexts.length === 2) {
      return state.resourceTexts.find(r => r.type === 3002)
    } else {
      return JSON.parse(localStorage.resourceTexts).find(r => r.type === 3002)
    }
  },
  homeLogo: (state) => {
    if (state.resources.length > 0) {
      return state.resources.find(r => r.type === 1003)
    } else {
      return JSON.parse(localStorage.resources).find(r => r.type === 1003)
    }
  },
  homeTitleBackground: (state) => {
    if (state.resources.length > 0) {
      return state.resources.find(r => r.type === 1004)
    } else {
      return JSON.parse(localStorage.resources).find(r => r.type === 1004)
    }
  },
  newsTitleBackground: (state) => {
    if (state.resources.length > 0) {
      return state.resources.find(r => r.type === 1005)
    } else {
      return JSON.parse(localStorage.resources).find(r => r.type === 1005)
    }
  },
  newsTitleTopic: (state) => {
    if (state.resources.length > 0) {
      return state.resources.find(r => r.type === 1006)
    } else {
      return JSON.parse(localStorage.resources).find(r => r.type === 1006)
    }
  },
  avatar: (state) => {
    if (state.avatar) {
      return state.avatar
    } else {
      return JSON.parse(localStorage.avatar)
    }
  }
}

const mutations = {
  setResourceTexts (state, data) {
    state.resourceTexts = data
    localStorage.resourceTexts = JSON.stringify(state.resourceTexts)
  },
  setResources (state, data) {
    data.map((each) => {
      each.location = process.env.VUE_APP_OSS_ENDPOINT + each.location
    })
    state.resources = data
    // console.log('state.resources:', state.resources)
    localStorage.resources = JSON.stringify(state.resources)
  },
  setNews (state, data) {
    data.map((each) => {
      each.image = process.env.VUE_APP_OSS_ENDPOINT + each.image
    })
    state.news = data
  },
  setAvatar (state, data) {
    state.avatar = process.env.VUE_APP_OSS_ENDPOINT + data
  },
  addOrUpdate (state, data) {
    state.file[data.name] = data.loc
    state.status[data.name] = true
    state.path[data.name] = data.path
    state.fileListSize = 0
    for (let status in state.status) {
      if (state.status[status]) {
        state.fileListSize++
      }
    }
  },
  delete (state, id) {
    // console.log('------------')
    delete state.file.id
    delete state.status.id
    delete state.path.id
    state.fileListSize = 0
    for (let status in state.status) {
      if (state.status[status]) {
        state.fileListSize++
      }
    }
  }
}

const actions = {
  getNews ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(getFewNews)
        .then((res) => {
          commit('setNews', res.data.data)
          resolve()
        })
    })
  },
  getAuth () {
    if (!sessionStorage.OssCredential) {
      axios.get(getOSSAuth)
        .then((credential) => {
          sessionStorage.OssCredential = JSON.stringify(credential.data.Credentials)
        })
    } else {
      if (Date.parse(new Date(JSON.parse(sessionStorage.OssCredential).Expiration)) - new Date() < 0) {
        sessionStorage.removeItem('OssCredential')
        axios.get(getOSSAuth)
          .then((credential) => {
            sessionStorage.OssCredential = JSON.stringify(credential.data.Credentials)
          })
      }
    }
  },
  getFileList ({ commit, dispatch }, id) {
    dispatch('getAuth')
      .then(() => {
        axios.get(getWebsiteResourceByTypeAPI + id)
          .then((list) => {
            for (let loc of list.data) {
              getOssFile(loc.location, JSON.parse(sessionStorage.OssCredential))
                .then((res) => {
                  commit('addOrUpdate', { 'name': loc.resource_name, 'loc': res, 'path': loc.location })
                })
            }
          })
      })
  },
  getFileType ({ commit, dispatch }, type) {
    dispatch('getAuth')
      .then(() => {
        axios.get(getWebsiteResourceByTypeAPI + type)
          .then((file) => {
            getOssFile(file.data.location, JSON.parse(sessionStorage.OssCredential))
              .then((res) => {
                console.log(res)
                commit('addOrUpdate', { 'name': type, 'loc': res, 'path': file.data.location })
              })
          })
      })
  },
  getFileHeader ({ commit, dispatch }, type) {
    axios.get(getHeaderResourceByTypeAPI + type)
      .then((file) => {
        dispatch('getFilePublic', { 'file': file.data, 'type': type })
      })
  },
  getFileTypePublic ({ commit, dispatch }, type) {
    axios.get(getWebsiteResourceByTypeAPI + type)
      .then((file) => {
        // console.log(file.data)
        dispatch('getFilePublic', { 'file': file.data, 'type': type })
      })
  },
  getFileSingle ({ commit, dispatch }, file) {
    dispatch('getAuth')
      .then(() => {
        if (file.loc.indexOf('://') < 0) {
          getOssFile(file.loc, JSON.parse(sessionStorage.OssCredential))
            .then((res) => {
              commit('addOrUpdate', { 'name': file.name, 'loc': res, 'path': file.loc })
            })
        } else {
          commit('addOrUpdate', { 'name': file.name, 'loc': file.loc, 'path': file.loc })
        }
      })
  },
  getFilePublic ({ commit }, data) {
    // console.log(data)
    if (data.file.location.indexOf('://') < 0) {
      data.file.location = 'https://wudongmeiyu2020.oss-cn-shanghai.aliyuncs.com/' + data.file.location
    }
    commit('addOrUpdate', { 'name': data.type, 'loc': data.file.location, 'path': data.file.location })
  },
  getText ({ commit }, id) {
    axios.get(getWebsiteTextAPI + id)
      .then((text) => {
        // console.log(text)
        commit('addOrUpdate', { 'name': id, 'loc': text.data.data, 'path': text.data.color })
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
